<template>
  <div>
    <a
      href="#"
      class="r-form__item__header"
      :class="`r-form__item__header--${is_collapse ? 'show' : 'hide'}`"
      @click.prevent="is_collapse = !is_collapse"
    >
      <label>{{ $t(`shared.component.recipient_form.${type}-dbs`) }}</label>
      <span>{{ $tc('shared.component.recipient_form.number_count', numbers_count) }}</span>
    </a>

    <b-collapse :id="`db-fragment-${type}`" v-model="is_collapse" class="mt-2">
      <div class="db-list">
        <template v-if="databases.length <= 0">
          <div class="row">
            <div class="col-12 text-center pt-2 pb-2">
              {{ $t('shared.component.table.empty') }}
            </div>
          </div>
        </template>

        <template v-for="db in databases">
          <db-row
            :key="db.id"
            :value="db"
            :class="{ active: selected === db.id }"
            :need_show_range="need_show_range"
            :range_from_one="range_from_one"
            @input="update_range(db, $event)"
            @click.native="selected = db.id"
          />
        </template>
      </div>
    </b-collapse>
  </div>
</template>

<script>
  import DbRow from './input-recipients-databases-row';
  import isEqual from 'lodash-es/isEqual';

  export default {
    components: { DbRow },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      need_show_range: {
        type: Boolean,
        default: true
      },
      range_from_one: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      is_collapse: false,
      selected: null,
      databases: []
    }),

    computed: {
      numbers_count: function () {
        /* 
          TODO если выбрать две базы с получателями = 0, суммируется не правильно.
          Но сейчас это не отобразиться, так как у пользователья задисейблен выбор такиз баз.
        */
        let accum;
        if (this.range_from_one && this.value[0]?.range[0] > 0) {
          accum = 1;
        } else {
          accum = 0;
        }
        return this.value.map((i) => i.range[1] - i.range[0]).reduce((a, b) => a + b, accum);
      }
    },
    watch: {
      databases: {
        handler: function (value) {
          if (!isEqual(value, this.value)) {
            this.$emit('input', value);
          }
        },
        deep: true,
        immediate: true
      },
      value: {
        handler: function (value) {
          if (!isEqual(value, this.databases)) {
            this.databases = value;
          }
        },
        deep: true,
        immediate: false
      }
    },
    methods: {
      update_range(db, range) {
        db.range = range;
        this.$emit('input', this.databases);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .db-list {
    border: 1px solid $border-color;
  }
</style>
